import { CnSwitch, CnTooltip } from '@alife/cn-ui';
import cn from 'classnames';
import Draggable from 'react-draggable';
import React, { PureComponent, useEffect, useRef, useState } from 'react';
import { useSetState,  } from 'ahooks';

import styles from './index.scss';
import { useI18n } from '@alife/panda-i18n';

function RecordPortal(props) {
  const $i18n = useI18n();
  const [state, setState] = useSetState({
    isRecording: false,
    startRecordingTime: null,
    currentTime: null,
    countdownSeconds: 3,
  });
  const {
    countdownSeconds,
    isRecording,
    startRecordingTime,
    currentTime,
  } = state;

  const tempRef = useRef({});
  const startCountdown = () => {
    let countdownSeconds = 3;
    setState({
      countdownSeconds,
    });
    tempRef.current.intervalFlag = setInterval(() => {
      if (countdownSeconds > 1) {
        countdownSeconds -= 1;
        setState({
          countdownSeconds,
        });
      } else {
        startRecord();
      }
    }, 1000);
  };
  const stopCountdown = () => {
    if (tempRef.current.intervalFlag) {
      clearInterval(tempRef.current.intervalFlag);
      setState({
        countdownSeconds: null,
      });
      tempRef.current.intervalFlag = null;
    }
  };
  const handleToggleRecord = () => {
    if (state.isRecording) {
      stopRecord();
    } else {
      startRecord();
    }
  };

  const startRecord = () => {
    const currentTime = Date.now();
    stopCountdown();
    setState({
      currentTime,
      isRecording: true,
      startRecordingTime: currentTime,
    });
    props.onStart?.();
    tempRef.current.recordIntervalFlag = setInterval(() => {
      setState({
        currentTime: Date.now(),
      });
    }, 1000);
  };

  const stopRecord = () => {
    setState({
      isRecording: false,
    });
    props.onStop?.();
    if (tempRef.current.recordIntervalFlag) {
      clearInterval(tempRef.current.recordIntervalFlag);
      tempRef.current.recordIntervalFlag = null;
    }
  };
  useEffect(() => {
    const onHotkeyPress = (e) => {
      if (e.metaKey && e.shiftKey && e.keyCode === 76) {
        handleToggleRecord();
      }
    };
    window.addEventListener('keydown', onHotkeyPress);
    return () => {
      window.removeEventListener('keydown', onHotkeyPress);
    };
  }, [state]);
  useEffect(() => {
    startCountdown();
    // console.log('install');
    return () => {
      // console.log('uninstall');
      stopCountdown();
      stopRecord();
    };
  }, []);


  const renderRecordCnSwitch = () => {
    const RenderSwitch = (
      <CnSwitch
        className='cn-ui-intelli-assistant-record-switch'
        checked={isRecording}
        onChange={handleToggleRecord}
      />
    );
    return (
      <div className={cn('cn-ui-intelli-assistant-record-switch-control')}>
        {isRecording ? (
          <CnTooltip align='l' v2 trigger={RenderSwitch} popupProps={{'data-xreplay-ignored': true}} visible>
            {$i18n.get({
              id: 'ClickStopRecording',
              dm: '单击停止录制',
            })}
          </CnTooltip>
        ) : (
          RenderSwitch
        )}
      </div>
    );
  };
  const renderRecordingTime = () => {
    if (!isRecording) {
      return '';
    }

    let duration = currentTime - startRecordingTime;
    if (duration < 0) {
      duration = 0;
    }

    return formatTime(duration);
  };

  const renderCountdown = () => {
    if (isRecording) {
      return null;
    }

    if (countdownSeconds == null) {
      return null;
    }

    return (
      <div
        className={cn('cn-ui-intelli-assistant-record-countdown-spinning')}
        data-xreplay-ignored
      >
        <div className={cn('cn-ui-intelli-assistant-record-countdown-status')}>
          <div className={'cn-ui-intelli-assistant-record-countdown-inner'}>
            {countdownSeconds}
          </div>
        </div>
      </div>
    );
  };

  const renderInfoContent = () => {
    return (
      <>
        <div className={'cn-ui-intelli-assistant-record-time'}>
          {renderRecordingTime()}
        </div>
        <div className={'cn-ui-intelli-assistant-record-status'}>
          {!isRecording
            ? $i18n.get({
                id: 'NotRecorded',
                dm: '未录制',
              })
            : $i18n.get({
                id: 'Recording',
                dm: '未录制中',
              })}
        </div>
      </>
    );
  };

  return (
    <>
      <Draggable axis='x' bounds='body'>
        <div
          className={'cn-ui-intelli-assistant-record-container'}
          data-xreplay-ignored
        >
          <div
            className={cn('cn-ui-intelli-assistant-record-portal', {
              visible: isRecording || countdownSeconds != null,
            })}
          >
            {renderRecordCnSwitch()}
            <div className={'cn-ui-intelli-assistant-record-recorder-info'}>
              {renderInfoContent()}
            </div>
          </div>
        </div>
      </Draggable>
      {renderCountdown()}
    </>
  );
}

export default RecordPortal;

export function formatTime(milliseconds) {
  let result = '';
  const h = Math.floor(milliseconds / 3600 / 1000);
  const s = Math.floor((milliseconds - h * 3600 * 1000) / 1000);
  result += `${Math.floor(s / 60)}:${format2Digits(s % 60)}`;
  return result;
}

function format2Digits(number) {
  return number < 10 ? `0${number}` : `${number}`;
}
